import React, { useContext } from "react";
import { Modal, Spinner } from "reactstrap";
import { Language } from "../../../App";
import "./AgendaPaymentDropInModal.css";

// Close SVG Icon matching design system
const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0E1421"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// Credit Card / Secure Lock Icon
const SecureLockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#00BADA"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const AgendaPaymentDropInModal = ({
  isOpen,
  toggle,
  title = "",
  formattedPrice = "",
  isInitializing = false,
  isProcessing = false,
  // True once Drop-in reports a payment method is actually requestable
  // (valid card incl. CVV, or a selected PayPal account) — gates the Pay
  // button below so a charge can't be attempted before there's anything to
  // submit. onPay is called on click; the charge itself never fires on its
  // own just from entering payment details.
  canPay = false,
  onPay,
  lang: propLang,
}) => {
  const { lang: contextLang } = useContext(Language) || {};
  const lang = propLang || contextLang;
  return (
    <Modal
      isOpen={isOpen}
      toggle={!isProcessing ? toggle : undefined}
      centered
      dialogClassName="agenda-payment-modal-dialog"
      contentClassName="agenda-payment-modal-content"
      fade={true}
      zIndex={10600}
      backdrop={isProcessing ? "static" : true}
    >
      <div className="agenda-payment-card">
        {/* Close Button */}
        <button
          type="button"
          className="agenda-payment-close-btn"
          onClick={toggle}
          aria-label="Close"
          disabled={isProcessing}
        >
          <CloseIcon />
        </button>

        {/* Header */}
        <div className="agenda-payment-header">
          <div className="agenda-payment-title-row">
            <h2 className="agenda-payment-title">
              {lang?.payment || "Complete Payment"}
            </h2>
            {formattedPrice && (
              <div className="agenda-payment-price-tag">
                {formattedPrice}
              </div>
            )}
          </div>
          {title && (
            <p className="agenda-payment-subtitle" title={title}>
              {title}
            </p>
          )}
        </div>

        {/* Secure Guarantee Pill */}
        <div className="agenda-payment-secure-pill">
          <SecureLockIcon />
          <span>{lang?.secure_payment_guarantee || "Secure & Encrypted Checkout with PayPal / Card"}</span>
        </div>

        {/* DropIn Container */}
        <div className="agenda-payment-body">
          {isInitializing && (
            <div className="agenda-payment-loading-state">
              <Spinner color="primary" size="md" />
              <span>{lang?.loading_payment_options || "Loading payment methods..."}</span>
            </div>
          )}
          <div
            id="dropin-container"
            style={{ width: "100%", display: isInitializing ? "none" : "block" }}
          ></div>
        </div>

        {/* Pay Button — the charge only fires on this click, never just from
            entering valid payment details above. */}
        {!isInitializing && !isProcessing && (
          <button
            type="button"
            className="agenda-payment-pay-btn"
            onClick={onPay}
            disabled={!canPay}
          >
            {formattedPrice
              ? `${lang?.pay || "Pay"} ${formattedPrice}`
              : lang?.pay || "Pay"}
          </button>
        )}

        {/* Processing Banner */}
        {isProcessing && (
          <div className="agenda-payment-processing-overlay">
            <Spinner color="primary" size="sm" />
            <span>{lang?.processing_payment || "Processing your payment & enrollment..."}</span>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AgendaPaymentDropInModal;
